var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStarStroke = function SvgStarStroke(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.498 10.08a.3.3 0 0 0-.175-.52l-6.33-.575a.3.3 0 0 1-.252-.187L12.278 2.69a.3.3 0 0 0-.556 0L9.259 8.81a.3.3 0 0 1-.252.186L2.68 9.56a.3.3 0 0 0-.176.52l4.828 4.403a.3.3 0 0 1 .09.287l-1.446 6.524a.3.3 0 0 0 .454.318l5.41-3.436a.3.3 0 0 1 .32 0l5.41 3.437a.3.3 0 0 0 .455-.318l-1.438-6.526a.3.3 0 0 1 .09-.286l4.82-4.403Zm-9.337 6.128a.3.3 0 0 0-.322 0l-2.988 1.899a.3.3 0 0 1-.454-.319l.805-3.629a.3.3 0 0 0-.09-.287l-2.69-2.456a.3.3 0 0 1 .175-.52l3.52-.321a.3.3 0 0 0 .251-.188l1.354-3.378a.3.3 0 0 1 .557 0l1.363 3.39a.3.3 0 0 0 .25.186l3.52.322a.3.3 0 0 1 .176.52l-2.69 2.456a.3.3 0 0 0-.09.287l.805 3.628a.3.3 0 0 1-.454.318l-2.998-1.908Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStarStroke);
export default ForwardRef;